import { useState, type ReactNode } from "react";
import { Accordion } from "../components/rumonai";

/**
 * The owner's own connection to a service, folded away while somebody else supplies one.
 *
 * It is the fallback and not the path: an owner whose Agent answers with the platform's models is not asked
 * for a provider, a model name and a pasted key. `open` is only where it starts; once the owner opens or
 * closes it, that is where it stays. A change the page makes to `open` is not the owner's doing.
 */
export function OwnServiceFold({ open, children }: { open: boolean; children: ReactNode }) {
  const [asked, setAsked] = useState<boolean | null>(null);
  const shown = asked ?? open;
  return <Accordion className="own-service" forceMount value={shown ? ["own"] : []}
    onValueChange={next => setAsked(next.includes("own"))}
    items={[{ value: "own", title: "用自己的服务", content: children }]} />;
}
